import React from 'react';
import {
  number, object, string, func,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import Responsive from '@active/react-utils/components/Responsive';
import { handleKeyboardEvent } from '../../../../../shared/utils/commonUtils';
import PaymentResultRefundInfo from '../PaymentResultRefundInfo';
import PromptMessage from '../../../information/PromptMessage';
import DateTime from '../../../DateTime';

const PaymentResultSwitch = ({
  title, switchText, toggleDetail, i18n,
  totalAmount, currencyCode, locale, orderDescription,
  businessDate,
}) => {
  return <div className="payment-result__switch">
    <div className="payment-result__switch-bar">
      <div className="second-level-title payment-result__switch-title">
        <h2 className='cui-mg-b-0'><Locale id={title} /></h2>
      </div>
      <div className="payment-result__switch-text">
        <Responsive eqAbove="md">
          <DateTime date={businessDate} locale={locale} />
          <div className="switch-link"
            role="button"
            aria-label={i18n(switchText)}
            tabIndex={0}
            onClick={toggleDetail}
            onKeyDown={handleKeyboardEvent(toggleDetail, 'Enter')}>
            <Locale id={switchText} />
          </div>
        </Responsive>
      </div>
    </div>
    <PaymentResultRefundInfo
      totalAmount={totalAmount}
      currencyCode={currencyCode}
      locale={locale}/>
    <PromptMessage message={orderDescription} />
    <Responsive not eqAbove="md">
      <div className="payment-result__switch-date">
        <DateTime date={businessDate} locale={locale} />
      </div>
    </Responsive>
  </div>;
};

PaymentResultSwitch.propTypes = {
  title: string,
  switchText: string,
  toggleDetail: func.isRequired,
  i18n: func.isRequired,
  totalAmount: number,
  currencyCode: string,
  locale: string,
  orderDescription: string,
  businessDate: object,
};

PaymentResultSwitch.defaultProps = {
  businessDate: {},
};

export default PaymentResultSwitch;
